<template>
    <div id="sig-container" class="full form-horizontal">
        <div class="loader" v-if="loading_historico">
            <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <contacto />
        <table-component :data="historico_abonos" pagination>
            <!-- <table-column slot="label" :label="'Asesor'" v-bind:value="'usuario.username'"></table-column> -->
            <table-column slot="label" :label="'Abono'" v-bind:value="'id'"></table-column>
            <table-column slot="label" :label="'Obligación'" v-bind:value="'id_garantia'"></table-column>
            <table-column slot="label" :filter="'numberFormat'" :label="'Valor'" v-bind:value="'valor'"></table-column>
            <table-column slot="label" :filter="'numberFormat'" :label="'Valor Total Abono'"
                v-bind:value="'total_abonado'"></table-column>
            <table-column slot="label" :label="'Fecha'" v-bind:value="'fecha'" :filter="'formatDate'"></table-column>
        </table-component>
        <div style="display: flex; align-items: center;justify-content: center;">
            <button @click="exportarPDF()" :disabled="historico_abonos.length == 0 || this.loading_historico"
                class="btn float-right btn-sm btn-primary py-0">
                Exportar PDF
            </button>
        </div>
    </div>
</template>

<script>
import FileSaver from "file-saver";

export default{
    name: 'HistoricoAbonos',
    data: () => {
        return {
            historico_abonos: [],
            loading_historico: true,
        }
    },
    components: {
        TableComponent: () => import("@@/components/table/TableComponent"),
        TableColumn: () => import("@@/components/table/TableColumn"),
        Contacto: () => import("@/views/Contacto.vue"),
    },
    methods: {
        getHistorico() {
            this.loading_historico = true;
            this.$store.dispatch("deudor/refresh_historico_gestion", []);
            this.$store
                .dispatch("index", {
                    endpoint: "abono/historico/" + this.$route.params.deudor_id,
                    params: {
                        paginar: false,
                    },
                })
                .then((response) => {
                    if (response.datos.length > 0) {
                        this.historico_abonos = response.datos;
                    } else {
                        this.$notify({
                        title: "Advertencia!",
                        type: "warning",
                        content:
                            "No se encontró información con el documento " + this.$route.params.deudor_id,
                        });
                    }
                    this.loading_historico = false;
                })
                .catch(() => {
                this.$notify({
                    title: "Advertencia!",
                    type: "danger",
                    content: "Se ha presentado un error realizando su consulta",
                });
                this.loading_historico = false;
            });
        },
        exportarPDF(){
        this.loading_historico = true;

        this.$store
            .dispatch("store", {
            endpoint: "utilidades/generar-documento-abonos-historico",
                params: this.historico_abonos,
                config: {
                    responseType: "arraybuffer",
                },
            })
            .then((response) => {
                var blob = new Blob([response], {
                    type: "application/pdf;charset=utf-8",
                });
                FileSaver.saveAs(
                    blob,
                    "Abonos_" + this.historico_abonos[0]["deudor_id"] + ".pdf"
                );
                this.$notify({
                    title: "Histórico Abonos",
                    type: "success",
                    content: "La descarga se completó con éxito",
                });
                this.loading_historico = false;
            })
            .catch((error) => {
                this.loading_historico = false;
                this.$notify({
                    title: "Histórico Abonos",
                    type: "warning",
                    content: "Los datos dados no son válidos",
                });
            });
        }
    },
    mounted(){
        this.getHistorico();
    }
}

</script>
